import { ReactNode } from 'react';

/**
 * Formats translated text by wrapping injected values with a `highlight` tag.
 *
 * Translation key example:
 * ```jsonc
 * {
 *   "itemsCount": "<highlight>{count}</highlight> photos"
 * }
 * ```
 *
 * Usage with `next-intl`:
 * ```tsx
 * t.rich('itemsCount', {
 *   highlight: RichTranslationText,
 *   count
 * });
 * ```
 *
 * @example
 * // Renders: <span class="...">3</span> photos
 * t.rich('itemsCount', { highlight: RichTranslationText, count: 3 });
 *
 */
export function RichTranslationText(chunks: ReactNode) {
  return (
    <span className="text-body-text ms-[0.5] font-mono font-bold">
      {chunks}
    </span>
  );
}
